class MobileMenuTabs extends window.BAO.CustomElement() {
  /**
   * @returns {void}
   */
  setupListeners () {
    this.storageKey = 'mobileMenuActiveTab'
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'))

    if (this.tabs.length === 0) return

    const activeTabIdentifier = this.getInitialActiveTabIdentifier()

    this.setActiveTab(activeTabIdentifier)

    this.tabs.forEach((tab) => {
      this.listeners.add(tab, 'click', () => {
        const tabIdentifier = tab.dataset.tab

        if (!tabIdentifier) return

        this.setActiveTab(tabIdentifier)
        this.saveActiveTabIdentifier(tabIdentifier)
      })

      this.listeners.add(tab, 'keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return

        event.preventDefault()

        const tabIdentifier = tab.dataset.tab

        if (!tabIdentifier) return

        this.setActiveTab(tabIdentifier)
        this.saveActiveTabIdentifier(tabIdentifier)
      })
    })
  }

  /**
   * @returns {string}
   */
  getInitialActiveTabIdentifier () {
    const fallbackIdentifier = this.tabs[0].dataset.tab
    const savedIdentifier = this.getSavedActiveTabIdentifier()

    if (!savedIdentifier) return fallbackIdentifier

    const savedTabExists = this.tabs.some(
      (tab) => tab.dataset.tab === savedIdentifier,
    )

    return savedTabExists ? savedIdentifier : fallbackIdentifier
  }

  /**
   * @returns {string|null}
  */
  getSavedActiveTabIdentifier () {
    try {
      return window.localStorage.getItem(this.storageKey)
    } catch (error) {
      this.log(
        'MobileMenuTabs: unable to read the active tab from localStorage',
        error,
      )

      return null
    }
  }

  /**
   * @param {string} identifier
   *
   * @returns {void}
   */
  saveActiveTabIdentifier (identifier) {
    try {
      window.localStorage.setItem(this.storageKey, identifier)
    } catch (error) {
      console.error(
        `MobileMenuTabs: unable to save the active tab to localStorage: ${error}`,
      )
    }
  }

  /**
   * @param {string} activeIdentifier
   *
   * @returns {void}
   */
  setActiveTab (activeIdentifier) {
    if (!activeIdentifier) return

    const activeMenu = this.externalEls[activeIdentifier]

    if (!activeMenu?.exists) {
      this.log(
        `MobileMenuTabs: no menu found for "${activeIdentifier}"`,
        this.externalEls,
      )

      return
    }

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === activeIdentifier

      tab.setAttribute('aria-selected', String(isActive))
      tab.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    Object.entries(this.externalEls).forEach(
      ([menuIdentifier, externalElement]) => {
        const isActive = menuIdentifier === activeIdentifier

        externalElement.elements.forEach((menu) => {
          menu.hidden = !isActive
          menu.setAttribute('aria-hidden', String(!isActive))
        })
      },
    )
  }
}

if (!customElements.get('mobile-menu-tabs')) {
  customElements.define('mobile-menu-tabs', MobileMenuTabs)
}
